import { getTranslatedString } from 'helpers/i18n';

export const getDurationStringInMonths = (duration) => {
  if (duration === 'monthly') {
    return getTranslatedString('landlordPortal.leaseCreatorV2.monthly');
  }
  if (duration === 1) {
    return `${duration} ${getTranslatedString('landlordPortal.leaseCreatorV2.month')}`;
  } else if (duration > 1) {
    return `${duration} ${getTranslatedString('landlordPortal.leaseCreatorV2.months')}`;
  }
};
